import { useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import Center from '../../assets/styles/Center';
import FormContainer from '../../assets/styles/FormContainer';
import ChangePageAuth from '../../components/ChangePageAuth';
import FormAuth from '../../components/FormAuth';
import GroupCheck from '../../components/GroupCheck';
import GroupInput from '../../components/GroupInput';
import Title from '../../components/Title';
import { useLoginUser } from '../../hooks/mutations/useUserMutations';
import useErrors from '../../hooks/useErrors';
import { useStore } from '../../stores/index';
import isEmailValid from '../../utils/isEmailValid';

export default function ClientLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [stayConnected, setStayConnected] = useState(false);

  const navigate = useNavigate();
  const login = useStore((state) => state.login);
  const { mutate: loginUser, isPending } = useLoginUser();

  const { setError, removeError, getErrorMessageByFieldName, errors } =
    useErrors();

  function handleEmail(e) {
    setEmail(e.target.value);

    if (!e.target.value) {
      setError({ field: 'email', message: 'O email é necessário' });
    } else {
      removeError('email');
    }
    removeError('password');
  }

  function handlePassword(e) {
    setPassword(e.target.value);

    if (!e.target.value) {
      setError({ field: 'password', message: 'O email é necessário' });
    } else {
      removeError('password');
    }
    removeError('email');
  }

  function handleStayConnected(e) {
    setStayConnected(e.target.checked);
  }

  function onSubmit() {
    if (!email) {
      setError({ field: 'email', message: 'O email está vazio' });
      return;
    }

    if (!isEmailValid(email)) {
      setError({ field: 'email', message: 'O email não é valido' });
      return;
    }

    if (!password) {
      setError({ field: 'password', message: 'A senha é obrigátoria' });
      return;
    }

    loginUser(
      {
        email,
        password,
        type: 'client',
      },
      {
        onSuccess: ({ token, user }) => {
          const body = {
            token,
            id: user.id,
            email: user.email,
            type: user.type,
          };

          login(body);
          navigate('/clientdashboard');
        },
        onError: (error) => {
          switch (error.response?.data?.error) {
            case 'Email ou senha inválidos':
              setError({
                field: 'email',
                message: error.response?.data?.error,
              });
              setError({
                field: 'password',
                message: error.response?.data?.error,
              });
              break;

            case 'Email e senha são obrigatórios':
              setError({
                field: 'email',
                message: error.response?.data?.error,
              });
              setError({
                field: 'password',
                message: error.response?.data?.error,
              });
              break;

            default:
              toast.error('Erro ao fazer login!');
              break;
          }
        },
      }
    );
  }

  const isFormValid = Boolean(password || email) && errors.length === 0;

  return (
    <FormContainer>
      <Center className="center">
        <Title
          title="Entre na sua conta!"
          subtitle="É um prazer te ver de volta!"
        />

        <FormAuth
          onSubmit={onSubmit}
          // onGoogle={() => alert('Falta o google')}
          // googleText="Entrar com Google"
          buttonTitle="Entrar agora"
          buttonLinkText="Não possui conta? Crie uma agora"
          buttonLink="/clientregister"
          formValid={isFormValid}
          isLoading={isPending}
        >
          <GroupInput error={getErrorMessageByFieldName('email')}>
            <label>Email*</label>
            <input
              type="email"
              placeholder="Digite seu email*"
              value={email}
              onChange={handleEmail}
            />
          </GroupInput>

          <GroupInput
            password
            changePassword
            error={getErrorMessageByFieldName('password')}
          >
            <label>Senha*</label>
            <input
              type="text"
              placeholder="Digite a sua senha*"
              value={password}
              onChange={handlePassword}
            />
          </GroupInput>

          <div className="group">
            <GroupCheck check={stayConnected}>
              <input
                type="checkbox"
                checked={stayConnected}
                onChange={handleStayConnected}
              />
              <label>Se manter conectado</label>
            </GroupCheck>

            <Link
              to="/forgot-password"
              style={{ fontSize: '13px', color: '#aaa', textDecoration: 'none' }}
            >
              Esqueceu sua senha?
            </Link>
          </div>
        </FormAuth>

        <ChangePageAuth
          link="/modellogin"
          text="É uma acompanhante? Entre por aqui"
        />
      </Center>
    </FormContainer>
  );
}
